var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSparkle({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    overflow: "visible",
    style: {
      display: "block"
    },
    width: 46,
    height: 46,
    viewBox: "0 0 46 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Sparkle",
    d: "M23 0L27.2285 18.7715L46 23L27.2285 27.2285L23 46L18.7715 27.2285L0 23L18.7715 18.7715L23 0Z",
    fill: "#FF5227"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSparkle);
export default __webpack_public_path__ + "static/media/sparkle.112c775834ba100b6eefb51e2e54ecc2.svg";
export { ForwardRef as ReactComponent };